import {
    isOpenEndedRange,
    resolveOpenEndedSliderState,
    UNSET_RANGE_BOUND,
} from "../uncappedRangeSliderState";

/** The largest message count any message count slider offers. */
export const MAX_MESSAGE_COUNT = 200;

/** The smallest, and the value either bound takes when it is not set. */
export const MIN_MESSAGE_COUNT = UNSET_RANGE_BOUND;

/**
 * Whether a range runs as far as the message count filter can express, and so reads as "31+
 * messages" rather than as a pair of numbers.
 *
 * The message-flavoured defaults over `isOpenEndedRange`, and the sibling of
 * `isOpenEndedCallDuration`: both dimensions store the top of their scale as a real bound and both
 * read it back as "and over", so a user who drags the thumb to the end of the track and a drilldown
 * out of the last bucket end up with one filter rather than two that happen to look alike.
 */
export const isOpenEndedMessageCount = (
    min: number | undefined,
    max: number | undefined,
): boolean => isOpenEndedRange(min, max, MAX_MESSAGE_COUNT);

/**
 * How a message count range should be drawn on a slider. The message-flavoured defaults over
 * `resolveOpenEndedSliderState`.
 *
 * Shared for the same reason duration's is: the filter panel and the Conversations explorer drawer
 * both draw this slider, and the rule is easy to get subtly wrong in each.
 */
export const resolveMessageCountSliderState = (
    messageCount: number[] | undefined,
    options?: { maxBound?: number; unitLabel?: string },
): { value: number[]; underSlideLabel?: string } =>
    resolveOpenEndedSliderState(messageCount, {
        ceiling: MAX_MESSAGE_COUNT,
        maxBound: options?.maxBound,
        unitLabel: options?.unitLabel ?? "messages",
    });
